import { GetStaticProps } from 'next';

import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { SWRConfig } from 'swr';

import appAPI, { APP_END_POINT } from 'src/api/app';
import Seo from 'src/components/atoms/seo';
import Main from 'src/components/templates/main';
import SearchCourse from 'src/components/templates/searchCourses';
import config from 'src/config';

const CoursesSearch = ({ fallback }: any) => (
  <SWRConfig value={{ fallback }}>
    <Main coupon scrollToTop>
      <Seo />
      <SearchCourse />
    </Main>
  </SWRConfig>
);

type Params = {
  locale: string;
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { locale } = context as Params;
  const responseAppData = await appAPI.fetchAppData();
  return {
    props: {
      fallback: {
        [APP_END_POINT.CATEGORIES]: responseAppData.data?.categories || [],
      },
      ...(await serverSideTranslations(locale, ['common'])),
    },
    revalidate: config.REVALIDATE_SHORT,
  };
};

export default CoursesSearch;
